// src/components/Tenants/Styles/MessageTenantDialog.Style.js
// @flow

import { phoneInputCss } from '../../../css/phoneInput';

const messageTenantDialogStyles = {
  dialogFormCtr: (theme) => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    // The "xlarge" & "large" usage depends on className="xlarge" or "large" on the <form>
    '&.xlarge': {
      maxHeight: 600
    },
    '&.large': {
      maxHeight: 550
    }
  }),

  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),

  relative: (theme) => ({
    position: 'relative'
  }),

  grow: (theme) => ({
    flexGrow: 1
  }),

  secondInput: (theme) => ({
    marginTop: theme.spacing(2),
    '& *': {
      zIndex: 1
    }
  }),

  largeTextField: (theme) => ({
    '& *': {
      borderRadius: 0
    },
    '& label': {
      transform: 'translate(20px, 24px) scale(1)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      top: 0
    },
    '& .MuiOutlinedInput-notchedOutline legend': {
      display: 'none'
    },
    '& textarea': {
      padding: theme.spacing(1)
    },
    '& label.MuiInputLabel-shrink': {
      display: 'none',
      transform: 'translate(12px, -6px) scale(0.75)',
      fontSize: '1rem'
    }
  }),

  messageTenantDialogTitle: (theme) => ({
    fontSize: '1rem',
    padding: '24px 24px 8px 24px'
  }),

  errorMessagesCtr: (theme) => ({
    flexDirection: 'column'
  }),

  errorTooltip: (theme) => ({
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between'
  }),

  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem',
    marginRight: theme.spacing(2)
  }),

  textFieldCaptionRight2: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem',
    position: 'absolute',
    bottom: 0,
    right: 42
  }),

  textFieldCaptionLeft: (theme) => ({
    textAlign: 'left',
    color: theme.palette.primary.light,
    fontSize: '0.8rem',
    position: 'relative',
    left: 20,
    width: '100%'
  }),

  warning: (theme) => ({
    color: theme.palette.error.main,
    fontSize: '0.9rem'
  }),

  clickable: (theme) => ({
    cursor: 'pointer',
    textDecoration: 'underline'
  }),

  error: (theme) => ({
    color: theme.palette.status?.error?.main || theme.palette.error.main
  }),

  phoneInputCtr: (theme) => ({
    ...phoneInputCss
  }),

  recipientsCountLabel: (theme) => ({
    color: theme.palette.custom?.backgroundTextInfo || '#555',
    fontSize: '0.9rem'
  }),

  actionsCtr: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 24px 0px 24px',
    paddingTop: 0
  }),

  actionAttachImgBtn: (theme) => ({
    backgroundColor: '#fff',
    boxShadow: theme.shadows[2],
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  })
};

export default messageTenantDialogStyles;